// BusinessBar.jsx
import React from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import styles from "./MenuModal.module.scss";

import subscriptionIcon from "../../../static/icons/newsub.svg";
import voucherIcon from "../../../static/icons/vouchers.svg";
import spinconnecticon from "../../../static/icons/spinconnecticon.svg";
import iotIcon from "../../../static/icons/iotIcon.svg";
import switchIcon from "../../../static/icons/switch-account.svg";
import settingIcon from "../../../static/icons/settings.svg";
import termsIcon from "../../../static/icons/terms.svg";
import logoutIcon from "../../../static/icons/logout.svg";

const BusinessBar = ({ onClose, setSwitchProfileModal, onSettingsClicked, onTermsClicked, logoutHandler }) => {
  const { userInfo } = useSelector((state) => state.authReducer);
  const history = useHistory();

  const handlePush = (path) => {
    console.log("Navigating to:", path);
    history.push(path);
    onClose();
  };

  const items = [
    {
      label: "SPIN OS",
      icon: spinconnecticon,
      href: "/os",
      external: true,
    },
    {
      label: "IoT",
      icon: iotIcon,
      onClick: () => handlePush("/iot"),
    },
    {
      label: "Vouchers",
      icon: voucherIcon,
      onClick: () => handlePush("/vouchers"),
    },
    {
      label: "Subs",
      icon: subscriptionIcon,
      href: "/subscription",
      external: true,
    },
    {
      label: "Accounts",
      icon: switchIcon,
      onClick: setSwitchProfileModal,
    },
    {
      label: "Terms",
      icon: termsIcon,
      onClick: () => {
        onClose();
        if (onTermsClicked) {
          onTermsClicked();
        }
      },
    },
    {
      label: "Settings",
      icon: settingIcon,
      onClick: onSettingsClicked,
    },
  ];

  const logoutItem = {
    label: "Logout",
    icon: logoutIcon,
    onClick: logoutHandler,
  };

  const renderItem = ({ label, icon, onClick, href, external }) => {
    if (href) {
      return (
        <div key={label} className={styles.MenuModalItemContainer}>
          <a
            href={href}
            target={external ? "_blank" : "_self"}
            rel="noopener noreferrer"
            className={styles.MenuModalItemLink}
          >
            <div className={styles.MenuModalItemImageContainer}>
              <img src={icon} className={styles.MenuModalItemImage} alt="" />
            </div>
            <span className={styles.MenuModalItem}>{label}</span>
          </a>
        </div>
      );
    }

    return (
      <div
        key={label}
        className={styles.MenuModalItemContainer}
        onClick={onClick}
        role="button"
        tabIndex={0}
        onKeyPress={(e) => {
          if (e.key === "Enter" || e.key === " ") onClick?.();
        }}
      >
        <div className={styles.MenuModalItemImageContainer}>
          <img src={icon} className={styles.MenuModalItemImage} alt="" />
        </div>
        <span className={styles.MenuModalItem}>{label}</span>
      </div>
    );
  };

  return (
    <>
      <div className={styles.MenuModalMainItems}>
        {items.map((item) => renderItem(item))}
      </div>
      <div className={styles.MenuModalLogoutItem}>
        {renderItem(logoutItem)}
      </div>
    </>
  );
};

export default BusinessBar;
